import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function HistoryIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="HistoryIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <defs>
                <clipPath id="clip-path">
                    <rect id="Rectángulo_691" width="18.764" height="23.213" fill="#fff" />
                </clipPath>
            </defs>
            <g id="Grupo_116" transform="translate(0 -0.001)">
                <g id="Grupo_115" transform="translate(0 0)" clipPath="url(#clip-path)">
                    <path
                        id="Trazado_1836"
                        d="M14.636,26.22a.417.417,0,0,0-.461.032,6.95,6.95,0,0,1-11.551-4.6v-1.2a6.953,6.953,0,0,1,5.744-6.238.37.37,0,0,0,.278-.37v-1.73a.283.283,0,0,0-.123-.247.249.249,0,0,0-.279-.093A9.39,9.39,0,0,0,9.572,30.452a9.2,9.2,0,0,0,6.517-2.688.336.336,0,0,0,.123-.279.322.322,0,0,0-.154-.277Z"
                        transform="translate(-0.113 -7.239)"
                        fill="#fff"
                        fillRule="evenodd"
                    />
                    <path
                        id="Trazado_1837"
                        d="M27.263,14.206a5.382,5.382,0,0,1,.68.154.36.36,0,0,0,.433-.216l.71-1.544a.53.53,0,0,0,0-.309.382.382,0,0,0-.248-.186,7.645,7.645,0,0,0-1.451-.339.3.3,0,0,0-.309.093.391.391,0,0,0-.123.278v1.7a.366.366,0,0,0,.308.37"
                        transform="translate(-16.6 -7.239)"
                        fill="#fff"
                        fillRule="evenodd"
                    />
                    <path
                        id="Trazado_1838"
                        d="M35.854,18.428a.376.376,0,0,0,.494.031l1.329-1.05a.39.39,0,0,0,.124-.279.352.352,0,0,0-.094-.247A8.328,8.328,0,0,0,36.1,15.525a.379.379,0,0,0-.308-.062.556.556,0,0,0-.247.216l-.679,1.576a.341.341,0,0,0,.124.432,6.387,6.387,0,0,1,.864.742"
                        transform="translate(-21.453 -9.515)"
                        fill="#fff"
                        fillRule="evenodd"
                    />
                    <path
                        id="Trazado_1839"
                        d="M43.559,37.876a.39.39,0,0,0-.309-.124l-1.7.155a.4.4,0,0,0-.34.309,6.679,6.679,0,0,1-.74,2.162.345.345,0,0,0,.123.462l1.39.957a.314.314,0,0,0,.279.061.469.469,0,0,0,.247-.185,9.647,9.647,0,0,0,1.143-3.52.315.315,0,0,0-.093-.279"
                        transform="translate(-24.897 -23.249)"
                        fill="#fff"
                        fillRule="evenodd"
                    />
                    <path
                        id="Trazado_1840"
                        d="M23.178,28.93h-.03V28.9l-2.564-2.441a.376.376,0,0,0-.247-.123,1.118,1.118,0,0,0-.277.123l-.248.279a.407.407,0,0,0-.092.247.43.43,0,0,0,.092.277l2.379,2.255.093,3.922a.382.382,0,0,0,.4.371h.371a.376.376,0,0,0,.34-.4L23.3,29.177a.606.606,0,0,0-.123-.247"
                        transform="translate(-12.144 -16.219)"
                        fill="#fff"
                        fillRule="evenodd"
                    />
                    <path
                        id="Trazado_1841"
                        d="M41.033,25.8a7.44,7.44,0,0,1,.5,1.668.364.364,0,0,0,.4.277l1.7-.153a.385.385,0,0,0,.248-.123.319.319,0,0,0,.062-.279,9.515,9.515,0,0,0-.9-2.779.488.488,0,0,0-.247-.186.3.3,0,0,0-.31.093L41.126,25.37a.347.347,0,0,0-.093.432"
                        transform="translate(-25.242 -14.913)"
                        fill="#fff"
                        fillRule="evenodd"
                    />
                    <path
                        id="Trazado_1842"
                        d="M3.823,3.358a16.548,16.548,0,0,1,1.68-.7A7.133,7.133,0,0,1,7.4,2.2a2.838,2.838,0,0,1,1.823.357,3.53,3.53,0,0,1,1.287,1.572l-.036-.16a4.359,4.359,0,0,0-.929-1.8A3.72,3.72,0,0,0,7.432,1.144a8.859,8.859,0,0,0-2.286-.036c-.644.071-1.286.179-1.912.286L2.8,0,0,3.448,4.252,4.734Z"
                        transform="translate(0 0)"
                        fill="#fff"
                        fillRule="evenodd"
                    />
                </g>
            </g>
        </SvgIcon>
    );
}
